<script lang="ts">
  import Object from "./Object.svelte";
</script>

<Object {...$$props}>
  <path
    d="M19.98,39.8a1,1,0,0,0-.737-.772l-12-3A1,1,0,0,0,6,37V49a1,1,0,0,0,1.6.8l3.415-2.561,20.4,14.575a1,1,0,0,0,1.162,0l20.4-14.575L56.4,49.8A1,1,0,0,0,58,49V37a1,1,0,0,0-1.243-.97l-12,3A1,1,0,0,0,44.4,40.8l2.748,2.061L37,48.326V35H47a1,1,0,0,0,1-1V28a1,1,0,0,0-1-1H37V22.634A10.708,10.708,0,0,0,43,13a11,11,0,0,0-21.893-1.556A10.81,10.81,0,0,0,27,22.633V27H17a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1H27V48.326L16.852,42.861,19.6,40.8A1,1,0,0,0,19.98,39.8ZM27.526,50.88A1,1,0,0,0,29,50V34a1,1,0,0,0-1-1H18V29H28a1,1,0,0,0,1-1V22a1,1,0,0,0-.6-.916,8.738,8.738,0,0,1-5.311-9.367,9.043,9.043,0,0,1,7.88-7.659A9,9,0,0,1,41,13a8.769,8.769,0,0,1-5.4,8.084A1,1,0,0,0,35,22v6a1,1,0,0,0,1,1H46v4H36a1,1,0,0,0-1,1V50a1,1,0,0,0,1.474.88l13-7A1,1,0,0,0,49.6,42.2l-2.319-1.74L56,38.281V47l-2.4-1.8a1,1,0,0,0-1.181-.014L32,59.771,11.581,45.186A1,1,0,0,0,10.4,45.2L8,47V38.281l8.719,2.179L14.4,42.2a1,1,0,0,0,.126,1.68Z"
  /><path
    d="M32,10a3,3,0,1,0,3,3A3,3,0,0,0,32,10Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,32,14Z"
  /><path d="M31,25h2V18H32a5,5,0,1,1,5-5h2a7,7,0,1,0-8,6.929Z" /><rect
    x="31"
    y="31"
    width="2"
    height="10"
  />
  <rect x="31" y="54" width="2" height="2" /><rect
    x="31"
    y="27"
    width="2"
    height="2"
  /></Object
>
